import type { Unit } from "./types";

/** Walking minutes between two units (haversine × detour factor at 4.8 km/h), 0 for the same unit. */
export function travelMinutes(a: Unit | undefined, b: Unit | undefined): number {
  if (!a || !b || a.code === b.code) return 0;
  const R = 6371, rad = Math.PI / 180;
  const dLat = (b.lat - a.lat) * rad, dLng = (b.lng - a.lng) * rad;
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(a.lat * rad) * Math.cos(b.lat * rad) * Math.sin(dLng / 2) ** 2;
  const km = 2 * R * Math.asin(Math.sqrt(h)) * 1.35;
  if (km < 0.15) return 0;
  return Math.round((km / 4.8) * 60) + 3;
}
